import { getCurrentSpaceId, getSpaceMemberIdToEdit } from '@/components/App/selectors'
import { RootState } from '@/store'
import { getUsers } from '@/store/selectors'
import { mapToUser } from '@/utilities/UserUtilities'

const mapToSpaceMember = function (user: any, rolesInSpace: any) {
  return {
    ...mapToUser(user),
    rolesInSpace: rolesInSpace
  }
}

export const mapPaginatedUsers = (state: RootState) => {
  const currentPageUsers = state.spaceMembersPage.page
  if (currentPageUsers) {
    const currentSpaceId = getCurrentSpaceId(state)
    const users = getUsers(state)
    return currentPageUsers.map(pageUser => {
      return mapToSpaceMember(users.byId[pageUser], currentSpaceId && users.byId[pageUser].roles.spaces[currentSpaceId])
    })
  }
}
export const getTotalUsers = (state: RootState) => {
  return state.spaceMembersPage.totalUsers || 0
}
export const getStartIndex = (state: RootState) => {
  return state.spaceMembersPage.startIndex || 1
}
export const getFilter = (state: RootState) => {
  return state.spaceMembersPage.filter || ''
}
export const getSortingColumn = (state: RootState) => {
  return state.spaceMembersPage.sortingColumn
}
export const getIsEditingUser = (state: RootState) => {
  return state.spaceMembersPage.isEditingUser
}

export const hasBeenReset = (state: RootState) => {
  return state.spaceMembersPage.reset
}

export const getIsNewUser = (state: RootState) => {
  return state.spaceMembersPage.isNewUser
}

export const getSearchedNewUsersNotInCurrentSpace = (state: RootState) => {
  const searchedUsersNew = state.spaceMembersPage.searchedUsersNew
  if (searchedUsersNew) {
    const users = getUsers(state)
    return searchedUsersNew.map(pageUser => {
      return mapToSpaceMember(users.byId[pageUser], [])
    })
  }
}

// NEEDED FOR SPACE MEMBERS EDIT PAGE
export const getUserInCurrentSpaceToEdit = (state: RootState) => {
  const currentSpaceId = getCurrentSpaceId(state)
  const userIdToEdit = getSpaceMemberIdToEdit(state)
  if (userIdToEdit) {
    const usersInSpace = Object.keys(state.users.byId)
      .map(id => state.users.byId[id])
      .filter(user => user.spaces?.find((space: any) => space.spaceId === currentSpaceId) != null)

    const user = usersInSpace.find(user => user.id === userIdToEdit)

    return user ? mapToSpaceMember(user, currentSpaceId && user.roles.spaces[currentSpaceId]) : null
  } else {
    return null
  }
}
